import { useContext } from 'react';
import Scrollbar from 'src/components/Scrollbar';
import { SidebarContext } from 'src/contexts/SidebarContext';

import {
  Box,
  alpha,
  styled,
  Divider,
  useTheme,
  Drawer
} from '@mui/material';

import SidebarMenu from './SidebarMenu';
import Logo from 'src/components/LogoSign';

const SidebarWrapper = styled(Box)(
  ({ theme }) => `
        width: ${theme.sidebar.width};
        min-width: ${theme.sidebar.width};
        color: ${theme.colors.alpha.trueWhite[70]};
        position: relative;
        z-index: 7;
        height: 100%;
        padding-bottom: 68px;
`
);

function Sidebar() {
  const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);
  const closeSidebar = () => toggleSidebar();
  const theme = useTheme();

  return (
    <>
      <SidebarWrapper
        sx={{
          display: {
            xs: 'none',
            lg: 'inline-block'
          },
          position: 'fixed',
          left: 0,
          top: 0,
          background: theme.sidebar.background
        }}
      >
        <Scrollbar>
          <Box
            sx={{
              pt: 3,
              pb: 2,
              px: 2,
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <Box sx={{ width: 40 }}>
              <Logo />
            </Box>
            <Box sx={{ ml: 1.5, overflow: 'hidden' }}>
              <Box
                sx={{
                  fontSize: 14,
                  fontWeight: 700,
                  color: theme.colors.alpha.trueWhite[100],
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }}
              >
                AYOZAT PPV
              </Box>
              <Box
                sx={{
                  fontSize: 12,
                  color: alpha(theme.colors.alpha.trueWhite[100], 0.45),
                  whiteSpace: 'nowrap'
                }}
              >
                Admin Dashboard
              </Box>
            </Box>
          </Box>
          <Divider
            sx={{
              mx: 2,
              mb: 1,
              background: alpha(theme.colors.alpha.trueWhite[100], 0.08)
            }}
          />
          <SidebarMenu />
        </Scrollbar>
      </SidebarWrapper>
      <Drawer
        sx={{
          boxShadow: theme.sidebar.boxShadow
        }}
        anchor={theme.direction === 'rtl' ? 'right' : 'left'}
        open={sidebarToggle}
        onClose={closeSidebar}
        variant="temporary"
        elevation={9}
      >
        <SidebarWrapper
          sx={{
            background: theme.sidebar.background
          }}
        >
          <Scrollbar>
            <Box
              sx={{
                pt: 3,
                pb: 2,
                px: 2,
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Box sx={{ width: 40 }}>
                <Logo />
              </Box>
              <Box sx={{ ml: 1.5, overflow: 'hidden' }}>
                <Box
                  sx={{
                    fontSize: 14,
                    fontWeight: 700,
                    color: theme.colors.alpha.trueWhite[100],
                    whiteSpace: 'nowrap'
                  }}
                >
                  AYOZAT PPV
                </Box>
                <Box
                  sx={{
                    fontSize: 12,
                    color: alpha(theme.colors.alpha.trueWhite[100], 0.45),
                    whiteSpace: 'nowrap'
                  }}
                >
                  Admin Dashboard
                </Box>
              </Box>
            </Box>
            <Divider
              sx={{
                mx: 2,
                mb: 1,
                background: alpha(theme.colors.alpha.trueWhite[100], 0.08)
              }}
            />
            <SidebarMenu />
          </Scrollbar>
        </SidebarWrapper>
      </Drawer>
    </>
  );
}

export default Sidebar;
